<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                E-Mail-Listen verwalten
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <!-- This example requires Tailwind CSS v2.0+ -->
                    <div class="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul class="divide-y divide-gray-200">
                            <li v-for="list in lists">
                                <inertia-link :href="route('email.list', {list: list})" class="block hover:bg-gray-50">
                                    <div class="px-4 py-4 flex items-center sm:px-6">
                                        <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                                            <div class="truncate">
                                                <div class="flex text-sm">
                                                    <p class="font-medium text-indigo-600 truncate">{{ list.name }}</p>
                                                    <p class="ml-1 flex-shrink-0 font-normal text-gray-500">
                                                        ({{ list.subscriber_count ?? 0 }} Abonennt{{ list.subscriber_count!=1 ? "en" : "" }})
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ml-5 flex-shrink-0">
                                            <!-- Heroicon name: solid/chevron-right -->
                                            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                </inertia-link>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import FarmTitle from "@/Layouts/FarmTitle";

export default {
    name: "Index",
    components: {FarmTitle, AppLayout},
    props: ['lists', 'farm']
}
</script>

<style scoped>

</style>
